import React from "react";
import DashboardHeader from "../../components/DashboardHeader";
import { landingPageOptions } from "./landingPageOptions";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import DashboardSidebar from "../../components/DashboardSidebar";
import ProfileSidebar from "../../components/ProfileSidebar";

const Landing = () => {
  const { user } = useAuth();
  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="dashboard-container px-6 py-2">
      <DashboardHeader showLogo />
      {/* <div className='font-size-medium text-center font-[500] font-["Fraunces"] self-center mt-8'>
        KICS - Keventers Internal Communication System
      </div> */}
      <div className="flex flex-wrap gap-x-10 gap-y-10 justify-center mt-16">
        {landingPageOptions.map((option, i) => {
          return (
            <Link key={`landing-option-${i}`} to={option.link}>
              <div className="flex flex-col items-center justify-center cursor-pointer min-w-[18rem] min-h-[19.6rem] px-4 py-6 bg-white rounded-[1rem]">
                <img
                  src={option.icon}
                  alt={option.title}
                  className={"w-[8rem] mb-2"}
                />
                <div className="font-size-small font-family-medium mt-7">
                  {option.title}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <DashboardSidebar />
      <ProfileSidebar />
    </div>
  );
};

export default Landing;
